import { useVerificationFlow } from "./useVerificationFlow";
import { useMemo } from "react";
import useVerificationQuestions from "./useVerificationQuestions";

export default function usePaymentVerificationStatus() {
  const { data: { results } = {} } = useVerificationFlow({
    state: "inflow",
    flowType: "fraudulent_payment",
  });

  const { data: { results: questionResults } = {} } = useVerificationQuestions({
    flowType: "fraudulent_payment",
  });

  const hasUnansweredQuestions = useMemo(() => {
    return !!questionResults?.filter((item) => item.answer === null)?.length;
  }, [questionResults]);

  const fraudulentPayment = results?.[0];
  const { needs_evidence, id_verification_required } = fraudulentPayment || {};

  return useMemo(() => {
    const getStatus = () => {
      if (!fraudulentPayment) return null;

      if (hasUnansweredQuestions) return "additional-questions";

      if (needs_evidence) return "needs-evidence";

      if (id_verification_required) return "needs-id";

      return "in-review";
    };

    const status = getStatus();

    return {
      status,
      updated_at: results?.[0]?.updated_at,
    };
  }, [
    fraudulentPayment,
    needs_evidence,
    hasUnansweredQuestions,
    results,
    id_verification_required,
  ]);
}
